/** Serialize a sheet-to-payment handoff; cancellation prevents post-unmount work. */
export function createPaymentHandoff() {
  let timer = null;
  let generation = 0;
  return {
    isPending: () => timer !== null,
    getGeneration: () => generation,
    // Web modal teardown uses a shorter handoff than native sheet dismissal.
    schedule(action, delay = 180, expectedGeneration = generation) {
      if (timer !== null || expectedGeneration !== generation) return false;
      timer = setTimeout(() => {
        timer = null;
        action();
      }, delay);
      return true;
    },
    cancel() {
      generation += 1;
      if (timer !== null) clearTimeout(timer);
      timer = null;
    },
  };
}
